import { render, staticRenderFns } from "./form-card-password-reset-request.vue?vue&type=template&id=38351e90&"
import script from "./form-card-password-reset-request.vue?vue&type=script&lang=js&"
export * from "./form-card-password-reset-request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports